import ready from '../utils/ready';

// Reset all navigation classes
const resetNavigation = () => {
  document
    .querySelector('.header')
    ?.querySelectorAll(
      '.header__nav-item, .header__subnav-item, .header__subnav-item, .header__subnav-header'
    )
    .forEach((el) => {
      el.classList.remove('header__nav--mobile-is-open'); // Mobile menu
      el.classList.remove('header__nav-item--mobile-is-hidden'); // Mobile subnav
      el.classList.remove('header__nav-item--mobile-is-drilled'); // Mobile subnav level 1 & 2
      el.classList.remove('header__nav-item--desktop-menu-open'); // Desktop menu
      el.classList.remove('header__subnav-item--desktop-menu-open'); // Reset subnav level 2
      el.classList.remove('header__subnav-item--mobile-is-hidden'); // Mobile reset subnav level 2 & 3
      el.classList.remove('header__subnav-item--mobile-is-drilled'); // Mobile reset subnav level 2 & 3
      el.classList.remove('header__subnav-header--mobile-is-hidden'); // Mobile reset subnav headers
    });
};

const initializeTopNavigation = () => {
  //Close Desktop Navigation on outside click
  document.addEventListener('click', (event) => {
    if ((event.target as Element | null)?.closest('.header')) {
      return;
    }

    resetNavigation();
  });

  // Open Mobile Navigation
  document.getElementById('header-nav-open-menu')?.addEventListener('click', () => {
    resetNavigation();

    document.getElementById('header-nav')?.classList.add('header__nav--mobile-is-open');
  });

  // Close Mobile Navigation
  document.getElementById('header-nav-close-menu')?.addEventListener('click', () => {
    resetNavigation();

    document.getElementById('header-nav')?.classList.remove('header__nav--mobile-is-open');
  });

  // Navigation Level 1 (nav)
  document.querySelectorAll('.header__nav-btn').forEach((el) => {
    el.addEventListener(
      'click',
      () => {
        const navList = el.closest<HTMLUListElement>('.header__nav-list');
        const navItems = navList?.querySelectorAll<HTMLLinkElement>('.header__nav-item');
        const subLinks = navList?.querySelectorAll<HTMLLIElement>('.header__subnav-item');

        // Toggle desktop menu
        el.closest('.header__nav-item')?.classList.toggle('header__nav-item--desktop-menu-open');

        // Close desktop subnav items
        subLinks?.forEach((el) => {
          el.classList.remove('header__subnav-item--desktop-menu-open');
        });

        navItems?.forEach((navItem) => {
          if (navItem === el.parentElement) return;

          // Close currently open desktop nav
          navItem.classList.remove('header__nav-item--desktop-menu-open');

          // Hide siblings in mobile
          navItem.classList.add('header__nav-item--mobile-is-hidden');
        });

        // Add mobile "is drilled" class to siblings
        el.closest('.header__nav-item')?.classList.add('header__nav-item--mobile-is-drilled');
      },
      false
    );
  });

  // Navigation Level 2 & 3 (subnav level 1 & 2)
  document.querySelectorAll('.header__subnav-btn').forEach((el) => {
    el.addEventListener(
      'click',
      () => {
        const parent = el.closest('.header__subnav-list');
        const subNavItems = parent?.querySelectorAll('.header__subnav-item');
        const allSubNavItems = parent?.children ? Array.from(parent?.children || []) : undefined;

        // Rest open state on desktop
        subNavItems?.forEach((subNavItem) => {
          if (subNavItem === el.parentNode) return;

          subNavItem.classList.remove('header__subnav-item--desktop-menu-open');
        });

        // Hide all other subnav items on same level
        allSubNavItems?.forEach((allSubNavItem) => {
          if (allSubNavItem === el.parentNode) return;

          allSubNavItem.classList.add('header__subnav-item--mobile-is-hidden');
        });

        // Desktop open clicked subnav
        el.closest('.header__subnav-item')?.classList.add('header__subnav-item--desktop-menu-open');

        // Mobile hide subnav level 1 header
        const parentSubnavWrapper = el.closest('.header__subnav-wrapper');
        const parentSubnavHeader = parentSubnavWrapper?.querySelector('.header__subnav-header');
        parentSubnavHeader?.classList.add('header__subnav-header--mobile-is-hidden');

        // Mobile open clicked subnavheader__nav-item--mobile-is-drilled
        el.closest('.header__subnav-item')?.classList.add('header__subnav-item--mobile-is-drilled');
      },
      false
    );
  });

  // Mobile Subnav Back Button (level 1)
  document.querySelectorAll('.header__subnav-header-btn--level-1').forEach((el) => {
    el.addEventListener(
      'click',
      () => {
        /// Show parent list
        el.closest('.header__nav-list')
          ?.querySelectorAll('.header__nav-item')
          .forEach((parentItem) => {
            parentItem.classList.remove('header__nav-item--mobile-is-hidden');
            parentItem.classList.remove('header__nav-item--mobile-is-drilled');
          });
      },
      false
    );
  });

  // Mobile Subnav Back Button (level 2)
  document.querySelectorAll('.header__subnav-header-btn--level-2').forEach((el) => {
    el.addEventListener(
      'click',
      () => {
        // Show parent list
        const parent = el.closest('.header__subnav');
        parent?.querySelectorAll('.header__subnav-item')?.forEach((parentItem) => {
          parentItem.classList.remove('header__subnav-item--mobile-is-hidden');
          parentItem.classList.remove('header__subnav-item--mobile-is-drilled');
        });

        // Show previous hidden Subnav Headers
        parent?.querySelectorAll('.header__subnav-header')?.forEach((subNavHeader) => {
          subNavHeader.classList.remove('header__subnav-header--mobile-is-hidden');
        });
      },
      false
    );
  });
};

ready(initializeTopNavigation);
